import React, { useEffect } from "react";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  Button,
  Table,
  Card,
  Col,
  Form,
  Row,
  Accordion,
} from "react-bootstrap";

import moment from "moment";
import { IconHistory } from "@tabler/icons-react";
import Lottie from "lottie-react";
import notfoundData from "../../../assets/not_found.json";
import Stepper from "../../../components/Stepper";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS, formatStringKey } from "../../../constant/_constant";
import { trimTrailingZeros } from "../../../utils/_helpers";

function SKU_Version_POPUP({ show, setShow, rfqSku }) {
  const [currentStep, setCurrentStep] = useState(1);

  const { postData: fetchRFQ_Version, data: dataver } = usePostRequest(
    API_ENDPOINTS.GET_VERSION_PROJECT,
  );

  const { postData: fetchRFQ_HISTORY, data } = usePostRequest(
    API_ENDPOINTS.GET_PROJECT_REVISION_HISTORY,
  );

  const options = ["Product Revisions", "Changes History"];

  const handleTabClick = (step) => {
    setCurrentStep(step);
  };

  const payloadData = {
    rfq_id: rfqSku,
  };

  useEffect(() => {
    fetchRFQ_Version(payloadData);
    fetchRFQ_HISTORY(payloadData);
  }, [rfqSku]);

  return (
    <Modal
      show={show}
      onHide={() => setShow({ show: false })}
      className="skusearch"
      dialogClassName="modal-90vw"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Body>
        <Stepper
          className="mt-3"
          steps={options}
          currentStep={currentStep}
          onTabClick={handleTabClick}
        />
        <Card.Subtitle
          className="text-center"
          style={{ position: "relative", top: "-25px" }}
        >
          Project ID: <strong>{rfqSku}</strong>
        </Card.Subtitle>
        {currentStep === 1 ? (
          <div className="table-responsive">
            <Table className="table-bordered">
              <thead responsive>
                <tr>
                  <th>VENDOR/PARTNER</th>
                  <th>PRODUCT NAME</th>
                  <th>SKU ID</th>
                  <th>SKU DESC.</th>
                  <th className="text-center">QTY</th>
                  <th className="text-center">ASPETTO'S COST($)</th>
                  <th className="text-center">Margin(%)</th>
                  <th className="text-center">Customer's Cost($)</th>
                  <th>Created Date </th>
                  <th>Updated Date</th>
                </tr>
              </thead>

              <tbody>
                {dataver?.data && dataver.data.length > 0 ? (
                  Array.from(
                    dataver.data.reduce((acc, item) => {
                      if (!acc.has(item.version_no))
                        acc.set(item.version_no, []);
                      acc.get(item.version_no).push(item);
                      return acc;
                    }, new Map()),
                  )
                    .sort((a, b) => b[0] - a[0])
                    .map(([versionNo, orders]) => (
                      <React.Fragment key={versionNo}>
                        <tr>
                          <td colSpan="11" className="p-0">
                            <div className="Revision_head">
                              Revision : <span className="">{versionNo}</span>{" "}
                              {orders[0]?.username && (
                                <span className="text-muted small">
                                  by {orders[0].username}
                                </span>
                              )}
                            </div>
                          </td>
                        </tr>
                        {orders.map((item, orderIndex) => {
                          if (item.changes_type === "removed") {
                            return (
                              <tr key={orderIndex} style={{ color: "red" }}>
                                <td style={{ textDecoration: "line-through" }}>
                                  {item["Vendor.display_name"] || "N/A"}
                                </td>
                                <td style={{ textDecoration: "line-through" }}>
                                  {item.name}
                                </td>
                                <td style={{ textDecoration: "line-through" }}>
                                  {item.sku_display_name}
                                </td>
                                <td>
                                  <span
                                    style={{ textDecoration: "line-through" }}
                                  >
                                    {item.description || "N/A"}
                                  </span>{" "}
                                  <span
                                    style={{
                                      color: "green",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Removed
                                  </span>
                                </td>
                                <td
                                  className="text-center"
                                  style={{ textDecoration: "line-through" }}
                                >
                                  {trimTrailingZeros(item.quantity)}
                                </td>
                                <td
                                  className="text-center"
                                  style={{ textDecoration: "line-through" }}
                                >
                                  {trimTrailingZeros(item.aspetto_price)}
                                </td>
                                <td
                                  className="text-center"
                                  style={{ textDecoration: "line-through" }}
                                >
                                  {trimTrailingZeros(item.margin_percent)}
                                </td>
                                <td
                                  className="text-center"
                                  style={{ textDecoration: "line-through" }}
                                >
                                  {Number(item.customer_price).toLocaleString(
                                    "en-US",
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    },
                                  )}
                                </td>
                                <td style={{ textDecoration: "line-through" }}>
                                  {moment(item.created_at).format("MM/DD/YYYY")}
                                </td>
                                <td style={{ textDecoration: "line-through" }}>
                                  {moment(item.updated_at).format("MM/DD/YYYY")}
                                </td>
                              </tr>
                            );
                          }

                          const np = item.new_product;
                          const isModified =
                            item.changes_type === "modified" && np;

                          const qtyChanged =
                            isModified &&
                            Number(item.quantity) !== Number(np.quantity);
                          const aspettoCostChanged =
                            isModified &&
                            Number(item.aspetto_price) !==
                              Number(np.aspetto_price);
                          const marginChanged =
                            isModified &&
                            Number(item.margin_percent) !==
                              Number(np.margin_percent);
                          const customerCostChanged =
                            isModified &&
                            Number(item.customer_price) !==
                              Number(np.customer_price);
                          const totalSKUCostChanged =
                            isModified &&
                            Number(item.total_price) !== Number(np.total_price);
                          const nameChanged =
                            isModified && (item.name || "") !== (np.name || "");
                          const vendorChanged =
                            isModified &&
                            (item["Vendor.display_name"] || "") !==
                              (np.vendor_name || "");

                          const descriptionChanged =
                            isModified &&
                            (item.description || "") !== (np.description || "");
                          return (
                            <tr key={orderIndex}>
                              <td>
                                {vendorChanged ? (
                                  <>
                                    <span
                                      style={{
                                        textDecoration: "line-through",
                                        color: "red",
                                        marginRight: "5px",
                                      }}
                                    >
                                      {item["Vendor.display_name"] || "N/A"}
                                    </span>
                                    {np.vendor_name || "N/A"}
                                  </>
                                ) : (
                                  item["Vendor.display_name"] || "N/A"
                                )}
                              </td>
                              <td>
                                {nameChanged ? (
                                  <>
                                    <span
                                      style={{
                                        textDecoration: "line-through",
                                        color: "red",
                                        marginRight: "5px",
                                      }}
                                    >
                                      {item.name || "N/A"}
                                    </span>
                                    {np.name || "N/A"}
                                  </>
                                ) : (
                                  item.name || "N/A"
                                )}
                              </td>
                              <td>{item.sku_display_name}</td>
                              <td>
                                {descriptionChanged ? (
                                  <>
                                    <span
                                      style={{
                                        textDecoration: "line-through",
                                        color: "red",
                                        marginRight: "5px",
                                      }}
                                    >
                                      {item.description || "N/A"}
                                    </span>
                                    {np.description || "N/A"}
                                  </>
                                ) : (
                                  item.description || "N/A"
                                )}{" "}
                                {item.changes_type === "new" && (
                                  <span
                                    className="blinking-text"
                                    style={{
                                      color: "green",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    New
                                  </span>
                                )}
                                {item.changes_type === "modified" && (
                                  <span
                                    style={{
                                      color: "#e6a700",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Modified
                                  </span>
                                )}
                              </td>
                              <td className="text-center">
                                {qtyChanged ? (
                                  <>
                                    <span
                                      style={{
                                        textDecoration: "line-through",
                                        color: "red",
                                        marginRight: "5px",
                                      }}
                                    >
                                      {trimTrailingZeros(item.quantity)}
                                    </span>
                                    {trimTrailingZeros(np.quantity)}
                                  </>
                                ) : (
                                  trimTrailingZeros(item.quantity)
                                )}
                              </td>

                              <td className="text-center">
                                {aspettoCostChanged ? (
                                  <>
                                    <span
                                      style={{
                                        textDecoration: "line-through",
                                        color: "red",
                                        marginRight: "5px",
                                      }}
                                    >
                                      {trimTrailingZeros(item.aspetto_price)}
                                    </span>
                                    {trimTrailingZeros(np.aspetto_price)}
                                  </>
                                ) : (
                                  trimTrailingZeros(item.aspetto_price)
                                )}
                              </td>

                              <td className="text-center">
                                {marginChanged ? (
                                  <>
                                    <span
                                      style={{
                                        textDecoration: "line-through",
                                        color: "red",
                                        marginRight: "5px",
                                      }}
                                    >
                                      {trimTrailingZeros(item.margin_percent)}
                                    </span>
                                    {trimTrailingZeros(np.margin_percent)}
                                  </>
                                ) : (
                                  trimTrailingZeros(item.margin_percent)
                                )}
                              </td>

                              <td className="text-center">
                                {customerCostChanged ? (
                                  <>
                                    <span
                                      style={{
                                        textDecoration: "line-through",
                                        color: "red",
                                        marginRight: "5px",
                                      }}
                                    >
                                      {Number(
                                        item.customer_price,
                                      ).toLocaleString("en-US", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}
                                    </span>
                                    {Number(np.customer_price).toLocaleString(
                                      "en-US",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      },
                                    )}
                                  </>
                                ) : (
                                  Number(item.customer_price).toLocaleString(
                                    "en-US",
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    },
                                  )
                                )}
                              </td>

                              <td>
                                {moment(item.created_at).format("MM/DD/YYYY")}
                              </td>
                              <td>
                                {moment(item.updated_at).format("MM/DD/YYYY")}
                              </td>
                            </tr>
                          );
                        })}
                      </React.Fragment>
                    ))
                ) : (
                  <tr>
                    <td colSpan={10}>
                      <div className="data_not_available text-center pb-4">
                        <Lottie animationData={notfoundData} />
                        <p> No revision history available.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        ) : (
          <div className="text-center">
            {data && data.data && data.data.length > 0 ? (
              data.data.map((item, index) => (
                <div className="rfq_box_item" key={index}>
                  <Accordion>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header className="accordian_items">
                        {item.User.username}{" "}
                        {moment(item.updated_at).format("MM/DD/YYYY HH:mm")}
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="mail_wrapper p-0 border-0 mb-0">
                          <div className="table-responsive">
                            <Table bordered>
                              <thead>
                                <tr>
                                  <th>Field</th>
                                  <th>Old Value</th>
                                  <th>New Value</th>
                                </tr>
                              </thead>
                              <tbody>
                                {item.changes_json.map((changeItem, idx) => {
                                  let change = changeItem.changes;
                                  return Object.keys(change).map(
                                    (key, idx2) => {
                                      const fieldChange = change[key];
                                      if (key === "other_cost") {
                                        return (
                                          <>
                                            {fieldChange.added &&
                                              fieldChange.added.length > 0 &&
                                              fieldChange.added.map(
                                                (addedItem, addedIdx) => (
                                                  <tr key={`added-${addedIdx}`}>
                                                    <td>
                                                      {`Other Cost: ${formatStringKey(addedItem.Name)}`}{" "}
                                                      <span
                                                        className="blinking-text"
                                                        style={{
                                                          color: "green",
                                                          fontWeight: "bold",
                                                        }}
                                                      >
                                                        New
                                                      </span>
                                                    </td>
                                                    <td>{"N/A"}</td>
                                                    <td>
                                                      {addedItem.Amount ||
                                                        "N/A"}
                                                    </td>
                                                  </tr>
                                                ),
                                              )}

                                            {fieldChange.removed &&
                                              fieldChange.removed.length > 0 &&
                                              fieldChange.removed.map(
                                                (removedItem, removedIdx) => (
                                                  <tr
                                                    style={{
                                                      textDecoration:
                                                        "line-through",
                                                      color: "red",
                                                      marginRight: "5px",
                                                    }}
                                                    key={`removed-${removedIdx}`}
                                                  >
                                                    <td
                                                      style={{ color: "red" }}
                                                    >
                                                      {`Other Cost: ${formatStringKey(removedItem.Name)}`}
                                                    </td>
                                                    <td
                                                      style={{ color: "red" }}
                                                    >
                                                      {removedItem.Amount ||
                                                        "N/A"}
                                                    </td>
                                                    <td
                                                      style={{ color: "red" }}
                                                    >
                                                      {"N/A"}
                                                    </td>
                                                  </tr>
                                                ),
                                              )}

                                            {fieldChange.modified &&
                                              fieldChange.modified.length > 0 &&
                                              fieldChange.modified.map(
                                                (modifiedItem, modifiedIdx) => (
                                                  <tr
                                                    key={`modified-${modifiedIdx}`}
                                                  >
                                                    <td>{`Other Cost: ${formatStringKey(modifiedItem.Name)}`}</td>
                                                    <td>
                                                      {modifiedItem.old_amount ||
                                                        "N/A"}
                                                    </td>
                                                    <td>
                                                      {modifiedItem.new_amount ||
                                                        "N/A"}
                                                    </td>
                                                  </tr>
                                                ),
                                              )}
                                          </>
                                        );
                                      } else {
                                        return (
                                          <tr key={`${idx}-${idx2}`}>
                                            <td>{formatStringKey(key)}</td>
                                            <td>{fieldChange.old || "N/A"}</td>
                                            <td>{fieldChange.new || "N/A"}</td>
                                          </tr>
                                        );
                                      }
                                    },
                                  );
                                })}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              ))
            ) : (
              <div className="data_not_available text-center pb-4">
                <Lottie animationData={notfoundData} />
                <p>No Opportunity history Available For this Quote.</p>
              </div>
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default SKU_Version_POPUP;
